// ─── CATEGORY TAXONOMY ────────────────────────────────────────────────────────
// Category icons render via the Lucide-based CategoryIcon component
// (src/lib/icons.js), not from this taxonomy — BRAND.md §7 forbids emoji.
export const CATEGORY_TAXONOMY = [
  { id: 'cookware',           en: 'Cookware & Bakeware',         ar: 'أواني الطهي والخبز',
    kw: ['pan','pot','wok','casserole','bakeware','cookware','roasting','frying','saucepan','stockpot','grill pan','griddle','dutch oven','cake pan','baking','tray','mold','mould','non-stick','nonstick','granite','granito','tajine','tagine','pressure cooker','crepe','pancake'] },
  { id: 'tableware',          en: 'Tableware & Dinnerware',      ar: 'أدوات المائدة',
    kw: ['plate','bowl','cup','mug','dinnerware','tableware','dish','platter','salad bowl','porcelain','ceramic','flatware','cutlery','fork','spoon','serving set','dinner set','tea set','coffee set','soup plate','charger','ramekin','chopsticks'] },
  { id: 'kitchen-tools',      en: 'Kitchen Tools & Utensils',    ar: 'أدوات وأواني المطبخ',
    kw: ['knife','peeler','grater','strainer','colander','spatula','ladle','whisk','tongs','scissors','chopper','slicer','cutting board','utensil','gadget','can opener','garlic press','mandoline','zester','funnel','masher','rolling pin','pastry brush','skimmer','baster','measuring','scale','timer','sieve','mortar'] },
  { id: 'kitchen-appliances', en: 'Kitchen Appliances',          ar: 'أجهزة المطبخ',
    kw: ['blender','mixer','kettle','toaster','air fryer','electric oven','microwave','coffee maker','juicer','rice cooker','electric','sandwich maker','waffle','grill machine','hand mixer','stand mixer','food processor','espresso','cappuccino','slow cooker','induction'] },
  { id: 'food-storage',       en: 'Food Storage & Organisation', ar: 'حفظ وتخزين الطعام',
    kw: ['container','storage box','jar','canister','organiser','organizer','pantry rack','tupperware','food box','airtight','vacuum seal','clip seal','dispenser','spice rack','condiment','bread box','fruit basket','egg holder'] },
  { id: 'drinkware',          en: 'Drinkware & Carriers',        ar: 'أكواب وعبوات',
    kw: ['thermos','tumbler','water bottle','travel mug','flask','insulated bottle','vacuum bottle','thermal mug','water jug','pitcher','carafe','ice bucket','wine glass','stemware','sports bottle'] },
  { id: 'decor',              en: 'Home Décor & Clocks',         ar: 'ديكور وساعات',
    kw: ['clock','picture frame','vase','candle holder','decoration','home decor','ornament','figurine','sculpture','wall art','mirror','oud','incense','diffuser','lantern','flower pot','artificial flower'] },
  { id: 'cleaning',           en: 'Cleaning & Laundry',          ar: 'التنظيف والغسيل',
    kw: ['mop','cleaning brush','sponge','broom','squeegee','window cleaner','cleaning cloth','vacuum','iron','steam iron','garment steamer','washing','scrub pad','lint roller','floor cleaner','toilet brush','waste bin'] },
  { id: 'bathroom',           en: 'Bathroom Accessories',        ar: 'أدوات الحمام',
    kw: ['soap dispenser','toothbrush holder','shower curtain','bathroom organizer','towel ring','bath mat','toilet paper holder','shampoo','lotion pump','vanity','makeup organizer'] },
  { id: 'other',              en: 'Other',                       ar: 'متنوع', kw: [] },
];

export const SHOPIFY_CAT_MAP = {
  'cookware': 'cookware', 'bakeware': 'cookware', 'cookware & bakeware': 'cookware',
  'kitchen tools': 'kitchen-tools', 'utensils': 'kitchen-tools', 'kitchen tools & utensils': 'kitchen-tools',
  'kitchen appliances': 'kitchen-appliances', 'kitchen appliance accessories': 'kitchen-appliances',
  'tableware': 'tableware', 'dinnerware': 'tableware', 'flatware': 'tableware', 'barware': 'tableware',
  'food storage': 'food-storage', 'storage & organization': 'food-storage',
  'food & beverage carriers': 'drinkware', 'beverage carriers': 'drinkware',
  'decor': 'decor', 'clocks': 'decor', 'home fragrance': 'decor', 'baskets': 'decor',
  'cleaning supplies': 'cleaning', 'laundry appliances': 'cleaning', 'laundry supplies': 'cleaning',
  'household cleaning': 'cleaning', 'vacuums': 'cleaning',
  'bathroom accessories': 'bathroom', 'soap & lotion dispensers': 'bathroom', 'toothbrush holders': 'bathroom',
};

export function autoCategory(nameEn, shopifyCat, tags) {
  const hay = [(nameEn || ''), (shopifyCat || ''), (tags || '')].join(' ').toLowerCase();
  if (shopifyCat) {
    const sc = shopifyCat.toLowerCase();
    for (const [k, v] of Object.entries(SHOPIFY_CAT_MAP)) {
      if (sc.includes(k)) return v;
    }
  }
  let bestScore = 0, bestId = 'other';
  for (const cat of CATEGORY_TAXONOMY) {
    if (cat.id === 'other') continue;
    let score = 0;
    for (const kw of cat.kw) { if (hay.includes(kw)) score += kw.split(' ').length; }
    if (score > bestScore) { bestScore = score; bestId = cat.id; }
  }
  return bestId;
}

export function catLabel(id, lang) {
  const c = CATEGORY_TAXONOMY.find(x => x.id === id);
  if (!c) return id || '—';
  return lang === 'ar' ? c.ar : c.en;
}

